<template>
  <v-dialog
    v-model="dialogProxy"
    width="600"
    scrollable
    persistent
    eager
    @keydown.esc="close"
    @click:outside="close"
  >
    <v-card class="app-card card-borderless">
      <gg-toolbar @close="close">
        Manage Users
      </gg-toolbar>
      <v-card-text class="pt-2 pb-3">
        <v-row>
          <v-col v-if="loadingUsers" cols="12" class="text-center">
            <v-progress-circular indeterminate size="64" color="primary" />
          </v-col>
          <template v-else-if="users.length">
            <v-col cols="12" class="pb-0">
              Managing users for "{{ path }}".
              To change a user’s password, add that user with the new password.
            </v-col>
            <v-col cols="12" class="pb-0">
              <gg-input-label>Select a User to delete:</gg-input-label>
              <v-radio-group v-model="user" column>
                <v-radio
                  v-for="usr in users"
                  :key="usr"
                  color="primary"
                  :value="usr"
                  :label="usr"
                />
              </v-radio-group>
            </v-col>
          </template>
          <v-col v-else cols="12">
            No users found. You can add users through "Add User" menu.
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-content-end pb-4 pt-0">
        <gg-btn secondary @click="close">Cancel</gg-btn>
        <gg-btn
          v-show="users.length"
          :disabled="!user"
          :loading="loadingDelete"
          @click="deleteUser"
        >
          Delete User
        </gg-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import amapi from '@/api/amapi'

export default {
  name: 'ManageUsersModal',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true,
      type: Boolean
    },
    path: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loadingUsers: false,
      loadingDelete: false,
      users: [],
      user: ''
    }
  },
  computed: {
    dialogProxy: {
      get () {
        return this.value
      },
      set (val) {
        if (!val) {
          this.$emit('close')
        }
        this.$emit('change', val)
      }
    }
  },
  methods: {
    ...mapActions({
      reportError: 'reportError'
    }),
    async loadUsers () {
      this.loadingUsers = true
      const data = {
        uapi_module: 'DirectoryPrivacy',
        uapi_function: 'list_users',
        dir: this.path,
        _username: this.$route.query.user,
      }
      try {
        const response = await amapi.cpanel_uapi(data)
        this.users = response?.data || []
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loadingUsers = false
      }
    },
    async deleteUser () {
      this.loadingDelete = true
      const data = {
        uapi_module: 'DirectoryPrivacy',
        uapi_function: 'delete_user',
        dir: this.path,
        user: this.user,
        _username: this.$route.query.user,
      }
      try {
        await amapi.cpanel_uapi(data)
        this.$emit('user-deleted')
        this.loadUsers()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loadingDelete = false
      }
    },
    close () {
      this.dialogProxy = false
    }
  },
  watch: {
    value (val) {
      if (val) {
        // load users for current path
        this.loadUsers()
      }
    }
  }
}
</script>

<style scoped>

</style>
